import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import useReveal from '../useReveal';
import Header from './Header';
import Footer from './Footer';

export default function SiteLayout() {
  const { pathname, hash } = useLocation();
  useReveal(pathname);

  useEffect(() => {
    if (hash) {
      const id = decodeURIComponent(hash.replace('#', ''));
      const frame = window.requestAnimationFrame(() => {
        const node = document.getElementById(id);
        if (node) {
          node.scrollIntoView();
        } else if (typeof window.scrollTo === 'function') {
          window.scrollTo(0, 0);
        }
      });
      return () => window.cancelAnimationFrame(frame);
    }

    window.scrollTo(0, 0);
    return undefined;
  }, [pathname, hash]);

  return (
    <div className="site" id="top">
      <Header />
      <main>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
